<template>
    <section class="details-blocks-container" ref="mainBlocksContainer" id="mainBlocksContainer">
        <div v-if="!pageLoaded" class="pdp-rabbit-blocks-section">
            <div class="flex-list">
                <div class="prz-blk skeleton-box"/>
                <div class="prz-blk skeleton-box"/>
                <div class="prz-blk pdp-block-horizontal skeleton-box"/>
            </div>
            <div class="flex-list">
                <div class="prz-blk pdp-block-horizontal skeleton-box"/>
                <div class="prz-blk skeleton-box"/>
                <div class="prz-blk skeleton-box"/>
            </div>
        </div>
        <FakeBlocks v-else-if="pageLoaded && renderFakeBlocks"/>
        <transition name="fade">
            <ProductDetailsBlocks v-if="!renderFakeBlocks && productDetailBlocks && tabsContentData"
                                :master-id="tabsContentData.masterId"
                                :sku="tabsContentData.sku"
                                :url="tabsContentData.url"
                                :socialUrl="tabsContentData.socialUrl"
                                :blocks-data="productDetailBlocks"
                                :render-pack-content-blocks="renderPackContentBlocks"
                                @scroll-into-view="scrollToContent"
            />
            <!-- This is for description creators to test Product Descriptions -->
            <BlockContentPopup v-else-if="updateDescription" id="blockContentPopup" :minimal-mode="true">
                <template v-slot:content>
                    <Description :url="descriptionTabUrl" :groupId="groupId" class="description-desktop"/>
                </template>
            </BlockContentPopup>
        </transition>
    </section>
</template>

<script>

import ProductDetailsBlocks from '@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/ProductDetailsBlocks.vue';
import FakeBlocks from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/FakeBlocks.vue";
import {storePdp} from '@/store/product-page';
import {isEmpty} from 'lodash-es';

import utilities from '@/Utilities/common';

export default {
    storePdp,
    name: 'ContentDetails',
    components: {
        FakeBlocks,
        ProductDetailsBlocks,
        Description: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/Description.vue'),
        BlockContentPopup: () => import('@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue'),
    },
    props: {
        pageLoaded: {
            type: Boolean,
            default: false
        },
        renderFakeBlocks: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
        };
    },

    computed: {
        kStrings() {
            return storePdp.getters.kStrings;
        },
        groupId() {
            return storePdp.getters.GroupId;
        },
        basicInfo() {
            return storePdp.getters['pdpDesktop/basicInfoData'];
        },
        productStatus() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/productStatus'];
        },
        activeProduct() {
            if (this.productStatus == 'NL' || this.productStatus == 'TI') {
                return true;
            }
            return this.productStatus == 'AC' || (this.basicInfo && this.basicInfo.isActive);
        },
        tabsContentData() {
            let tabsData = storePdp.getters['pdpDesktop/tabsData'];
            if(tabsData === null || tabsData === undefined){
                tabsData = {};
            }
            return tabsData;
        },
        descriptionTabUrl() {
            let descriptionTab = this.tabsContentData.tabsData.find(elm => elm.key == 'DESCRIPTION');
            return !isEmpty(descriptionTab) ? descriptionTab.url : this.tabUrl;
        },
        productDetailBlocks() {
            if(!this.activeProduct) {
                return null;
            }

            return storePdp.getters['pdpDesktop/productDetailBlocks']
        },
        productSocialBlocks() {
            if(!this.activeProduct) {
                return null;
            }

            return storePdp.getters['pdpDesktop/productSocialBlocks'];
        },
        renderPackContentBlocks() {
            if (!this.activeProduct) {
                return false;
            }

            return storePdp.getters['pdpDesktop/addToCartDesktop/isPack'] && !isEmpty(storePdp.getters['pdpDesktop/addToCartDesktop/selectedPackProducts']);
        },
        updateDescription(){
            return storePdp.getters['pdpDesktop/updateDescription'];
        }
        
    },
    methods: {
        scrollToContent(id = '') {
            let element = id ? document.getElementById(id) : this.$refs.mainBlocksContainer;
            if(!element) {
                id = "mainBlocksContainer";
                element = document.getElementById(id);
            }
            utilities.scrollIntoViewWithOffset(element, 76);
        }
    },
    watch: {},
    mounted() {
        this.$nextTick(() => {});
    },
};
</script>

<style lang="scss">
@import "./styles/BlocksSection/contentDetails.scss";
</style>
